<script lang="ts">
    import Layer from "../../../map/controls/layers/Layer.svelte";
    import type { RoutingManager } from "./RoutingManager";
    import {Readable, derived, writable} from "svelte/store";
    import Statistics from "./Statistics.svelte";
    import {GearIcon} from "@anyways-open/common-svgs";
    import { onMount } from "svelte";
    import ProfileRow from "./profiles/ProfileRow.svelte";
    import type { Score } from "../../../map/controls/layers/trips/dbs/Score";

    export let manager: RoutingManager;
    let expanded: boolean = true;
    let profileManagers = manager.getProfileManagers();
    let score = manager.getScoreStore();

    onMount(async () => {
        await manager.initialize();
    });
    
    const reverseRoute = () => {
        manager.reverse()
    };
</script>

<Layer {expanded} canSave={false} canVisible={false} canRemove={false}>
    <h3 slot="title" class="pb-1">Routes</h3>
    <div slot="content" class="container ps-2 pe-0 list-group">
        <Statistics {score} />

        <div class="row py-1 px-0 gx-0  fs-tool">
            <div class="d-flex">
                <div class="svg-icon-sm svg-icon-grey pe-1">
                    <GearIcon />
                </div>
                <div>Profiles</div>
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div
                        class="btn badge badge-rounded-circle badge-success-soft ms-auto"
                        on:click={() => reverseRoute()}>
                    <i class="fe fe-repeat" />
                </div>
            </div>
        </div>
        
        {#each profileManagers as profileManager}
            <ProfileRow manager={profileManager} />
        {/each}
    </div>
</Layer>